export const SUGGEST_REQUEST = 'SUGGEST_REQUEST';
